import { useContext, useEffect, useState } from "react";
import { Dropdown } from "primereact/dropdown";
import { Authorization } from "../../common/AuthorizationCpt";
import { getErrorValueResponse } from "../../common/error/Error";
import loadingGreen from "../../images/loading_gray.gif";
import { HTTP_METHODS } from "../../utils/constants";
import { networkBackendRequest } from "../../utils/networkUtils";
import { formatMoney, formatNumber } from "../../utils/numbers";
import CreditPaymentImporterModal from "../CreditPaymentImporterModal/CreditPaymentImporterModal";
import { CurrencyContext } from "../CurrencyContext/CurrencyContext";
import VolanteReviewingDocModal from "../VolanteReviewingDocModal/VolanteReviewingDocModal";
import {
  Container,
  ContentLabelCredit,
  DivInvoiceVolante,
  InvoiceContainer,
  InvoicesContainer,
  MainButton,
  OptionTemplateDiv,
  PayerContainer,
  PaymentContainer,
  PercentageBar,
} from "./CreditMethodStyles";
import { CreditThirdMethod } from "./CreditThirdMethod";
import { FileUploadCreditThirdModal } from "./FileUploadCreditThirdModal";
import { useAsyncExecutor, useAsyncExecutor2 } from "async-executor-hook";
import { DivIsLoadingIcon } from "../CollectionMethod/CollectionMethodStyles";
import LoadingGray from "../../images/loading_gray.gif";

function CreditMethod(props) {
  const {
    totalAmount,
    toggleModal,
    invoices,
    payerItems,
    hideModalPaymentType,
    hideModalPaymentTypeShowModal,
    updateMessageError1,
    setShowModalError1,
    setMessageSuccessCreditMethod,
    setModalSuccessCreditMethod,
    setShowModalThirdError,
    setMessageErrorThird,
    updateShowModal,
    setShowModalThirdSuccess,
    countPageRedirect,
    closeModal,
    dateUrlQuotationQuoted,
    getQuotationQuotedVolantes,
    volateQuoted,
    quotation_ids,
    clearShoppingCar,
  } = props;
  const [creditPercentage, updateCreditPercentage] = useState(0);
  const [payerRuc, updatePayerRuc] = useState("");
  const [payerRucOption, setPayerRucOption] = useState("");
  const [currentRemainingCredit, updateCurrentRemainingCredit] = useState(0);
  const [showCreditImporterModal, updateShowCreditImporter] = useState(null);
  const [reviewingDocVolantes, updateReviewingDocVolantes] = useState(false);

  const [showModalAgencyThird, setShowModalAgencyThird] = useState(false);

  const [useDollars] = useContext(CurrencyContext);
  useEffect(() => {
    const chosenPayerItem = payerItems.filter(
      (payerItem) => payerItem.payerRucOption === payerRuc
    )[0];
    if (chosenPayerItem) {
      const creditPercentage =
        (Number(chosenPayerItem.remainingCredit) * 100) /
        Number(chosenPayerItem.totalCredit);
      updateCurrentRemainingCredit(Number(chosenPayerItem.remainingCredit));
      updateCreditPercentage(creditPercentage);
    }
    if (chosenPayerItem?.payerRucOption !== "customs_agency") {
      updateCurrentRemainingCredit(Number(0));
      updateCreditPercentage(0);
    }
  }, [payerRuc, payerItems]);

  const messageInvoicesSuccess = `Se ha${
    invoices.length > 1 ? "n" : ""
  } facturado ${invoices.length} volante${
    invoices.length > 1 ? "s" : ""
  } al crédito con éxito. Puede verificarlo${
    invoices.length > 1 ? "s" : ""
  } en la pestaña de volantes facturados.`;

  const postCreateInvoice: any = useAsyncExecutor(
    (params: any) => {
      const quotation_ids = params.invoices.map((invoice) => {
        return invoice.id;
      });

      const body = {
        quotation_ids: quotation_ids,
        credit_payment_detail: {
          payer_ruc_option: params.payerRuc,
        },
      };
      return networkBackendRequest(
        "/invoices/credit/",
        HTTP_METHODS.POST,
        null,
        body
      ).then((resp) => resp.json());
    },
    {
      onSuccess: (_, params) => {
        getQuotationQuoted.execute({
          messageInvoicesSuccess: params.messageInvoicesSuccess,
          from_date: dateUrlQuotationQuoted,
        });
      },
      onError: (error) => {
        const errorMessage = getErrorValueResponse(error);
        clearShoppingCar();
        countPageRedirect(1);
        updateMessageError1(errorMessage);
        hideModalPaymentType();
        setShowModalError1(true);
      },
    }
  );

  const getQuotationQuoted: any = useAsyncExecutor2(
    (params: any) => {
      return networkBackendRequest("/quotations/quoted/", HTTP_METHODS.GET, {
        from_date: params.from_date,
      }).then((resp) => resp.json());
    },
    {
      onSuccess: (data, params) => {
        const count = data.count;
        setMessageSuccessCreditMethod(params.messageInvoicesSuccess);
        countPageRedirect(count);
        hideModalPaymentType();
        setModalSuccessCreditMethod(true);
      },
      onError: () => {
        countPageRedirect(1);
        hideModalPaymentType();
        setModalSuccessCreditMethod(true);
      },
    }
  );

  const [showUploadDocument, setShowUploadDocument] = useState(false);

  const [selectedRuc, updateSelectedRuc] = useState("");

  const [selectedCountry, setSelectedCountry] = useState(null);

  const onCountryChange = (e) => {
    setSelectedCountry(e.value);

    const chosenPayerItem = payerItems.filter(
      (payerItem) => payerItem.payerRucOption === e.value.payerRucOption
    )[0];
    if (e.value.payerRucOption === "third_party_agency") {
      setShowModalAgencyThird(true);
    } else if (chosenPayerItem.allowed === false) {
      updateCurrentRemainingCredit(null);
      updateShowCreditImporter(true);
      setPayerRucOption(e.value.payerRucOption);
    }
    updatePayerRuc(e.value.payerRucOption);
  };

  const countryOptionTemplate = (option) => {
    const third_party_agency = option.payerRucOption === "third_party_agency";
    return (
      <div style={{ cursor: "pointer", display: "flex", maxWidth: "63rem" }}>
        <OptionTemplateDiv
          marginRight={`${third_party_agency ? "0rem" : "0.5rem"}`}
        >
          {option.payerRuc}
        </OptionTemplateDiv>
        {!third_party_agency ? (
          <>
            <ContentLabelCredit>
              <label>
                {`${third_party_agency ? "" : " - "}`} {option.payerRucName}
              </label>
            </ContentLabelCredit>
            <ContentLabelCredit marginLeft="0.5rem">
              {`${third_party_agency ? "" : " - "}`} {option.label}
            </ContentLabelCredit>
          </>
        ) : (
          <ContentLabelCredit>{option.payerRucName}</ContentLabelCredit>
        )}
      </div>
    );
  };

  const selectedCountryTemplate = (option, props) => {
    if (option) {
      const payerRucOption = option.payerRucOption === "third_party_agency";
      return (
        <div>
          <div
            style={{
              color: "#000000",
              display: "flex",
              fontFamily: "Montserrat",
              fontSize: "1.4rem",
            }}
          >
            {payerRucOption ? (
              <div style={{ color: "#000000" }}>{option.payerRucName}</div>
            ) : (
              <div style={{ display: "flex" }}>
                <b>{option.payerRuc}</b>
                <div style={{ marginLeft: "0.5rem", color: "#000000" }}>
                  - {option.payerRucName}
                </div>
                <div style={{ marginLeft: "0.5rem", color: "#000000" }}>
                  - {option.label}
                </div>
              </div>
            )}
          </div>
        </div>
      );
    }
    return (
      <span
        style={{
          color: "#000000",
          fontFamily: "Montserrat",
          fontSize: "1.4rem",
        }}
      >
        {props.placeholder}
      </span>
    );
  };

  return (
    <>
      {hideModalPaymentTypeShowModal && (
        <Container>
          <h1>Forma de pago: Crédito</h1>
          <InvoicesContainer>
            {getQuotationQuotedVolantes.isLoading && (
              <DivIsLoadingIcon>
                <img src={LoadingGray} className="icon" alt="Loading screen" />
              </DivIsLoadingIcon>
            )}
            {volateQuoted.map((invoice) => (
              <InvoiceContainer key={invoice.id}>
                <div className="flex-contain-invoice">
                  <DivInvoiceVolante>
                    <div>
                      <span className="volante-id">{invoice.volanteId}</span>
                    </div>
                    <div>
                      <p className="invoice-id">{invoice.quotationNum}</p>
                    </div>
                  </DivInvoiceVolante>
                  <div className="invoce-importer">
                    <p className="importer">{invoice.importer}</p>
                  </div>
                </div>
              </InvoiceContainer>
            ))}
          </InvoicesContainer>
          <PaymentContainer>
            <div className="special-row">
              <p>Total factura</p>
              <p>
                {totalAmount == null
                  ? ""
                  : formatMoney(totalAmount, useDollars)}
              </p>
            </div>
          </PaymentContainer>
          <PayerContainer>
            <h2>RAZÓN SOCIAL DEL PAGADOR</h2>
            <Dropdown
              className="dropdown-credit-method-payment"
              panelClassName="panel-credit-method-dropdown"
              value={selectedCountry}
              options={payerItems}
              onChange={onCountryChange}
              optionLabel="name"
              placeholder="--seleccione--"
              valueTemplate={selectedCountryTemplate}
              itemTemplate={countryOptionTemplate}
              style={{ width: "10rem" }}
            />
            <div className="credit-info">
              <h2>LÍNEA DE CRÉDITO DISPONIBLE</h2>
              <PercentageBar percentage={creditPercentage} />
              <div className="percentage-container">
                {currentRemainingCredit !== null && (
                  <h3>{`$${formatNumber(currentRemainingCredit)} USD`}</h3>
                )}
              </div>
            </div>
          </PayerContainer>
          <Authorization actions={["invoice.create_invoice_credit"]}>
            <MainButton
              disabled={
                payerRuc.length === 0 ||
                totalAmount > currentRemainingCredit ||
                payerRuc === "cargo_agent" ||
                postCreateInvoice.isLoading ||
                getQuotationQuoted.isLoading ||
                payerRuc === "consignee" ||
                payerRuc === "third_party_agency"
              }
              onClick={() => {
                postCreateInvoice.execute({
                  invoices,
                  payerRuc,
                  messageInvoicesSuccess,
                });
              }}
              isLoading={
                postCreateInvoice.isLoading || getQuotationQuoted.isLoading
              }
            >
              {(postCreateInvoice.isLoading ||
                getQuotationQuoted.isLoading) && (
                <img
                  src={loadingGreen}
                  width="50"
                  height="50"
                  alt="Use credit"
                />
              )}
              Utilizar Crédito
            </MainButton>
          </Authorization>
          {showCreditImporterModal ? (
            <CreditPaymentImporterModal
              invoices={invoices}
              payerItems={payerItems}
              toggleModal={(success) => {
                if (success) {
                  toggleModal(true);
                  setSelectedCountry("");
                }
                updateShowCreditImporter(false);
                setSelectedCountry("");
              }}
              payerRucOption={payerRucOption}
              countPageRedirect={countPageRedirect}
              closeModal={closeModal}
              dateUrlQuotationQuoted={dateUrlQuotationQuoted}
              quotation_ids={quotation_ids}
              clearShoppingCar={clearShoppingCar}
            />
          ) : null}

          {reviewingDocVolantes ? (
            <VolanteReviewingDocModal
              toggleModal={() => updateReviewingDocVolantes(false)}
            />
          ) : null}
        </Container>
      )}

      {showModalAgencyThird && (
        <CreditThirdMethod
          onOutsideClick={() => {
            setShowModalAgencyThird(false);
            updatePayerRuc("");
            setSelectedCountry("");
          }}
          setShowUploadDocument={setShowUploadDocument}
          updateSelectedRuc={updateSelectedRuc}
          selectedRuc={selectedRuc}
          payerItems={payerItems}
          updateShowModal={updateShowModal}
          setShowModalThirdError={setShowModalThirdError}
          setMessageErrorThird={setMessageErrorThird}
        />
      )}
      {showUploadDocument && (
        <FileUploadCreditThirdModal
          onOutsideClick={() => {
            setShowUploadDocument(false);
          }}
          selectedRuc={selectedRuc}
          setShowModalThirdError={setShowModalThirdError}
          setMessageErrorThird={setMessageErrorThird}
          updateShowModal={updateShowModal}
          setShowModalThirdSuccess={setShowModalThirdSuccess}
          countPageRedirect={countPageRedirect}
          dateUrlQuotationQuoted={dateUrlQuotationQuoted}
          quotation_ids={quotation_ids}
          clearShoppingCar={clearShoppingCar}
        />
      )}
    </>
  );
}

export default CreditMethod;
